import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DialogLayout from '../common/dialog-layout';
import FeeSummary from './FeeReceipt';

function CheckTypeDialog({ open, onSave, onClose ,onCloseIcon }) {
    const allowed_trans_types = {
    "AK": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "AL": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "AR": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "AZ": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "CA": [
      { value: 'dl', label: 'Registration' },
      { value: 'vehicle', label: 'Title' } // Assuming 'vehicle' is a general document type
    ],
    "CO": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "DC": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "DE": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "FL": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "GA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "IA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "ID": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "KS": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "KY": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "LA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "MA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "MD": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "ME": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' }
    ],
    "MI": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "MN": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "MO": [
      { value: 'vehicle_title', label: 'Title' }
    ],
    "MS": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "MT": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "NC": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "ND": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "NE": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "NH": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "NJ": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "NM": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "NV": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "NY": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "OH": [
      { value: 'vehicle_registration', label: 'Registration' },
      { value: 'vehicle_title', label: 'Title' },
      { value: 'vehicle_title_registration', label: 'Both' }
    ],
    "OR": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "PA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "RI": [
      { value: 'vehicle_title', label: 'Title' }
    ],
    "SC": [
      { value: 'vehicle_title', label: 'Title' }
    ],
    "TN": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "TX": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "VA": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "WI": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "WV": [
      { value: 'vehicle_registration', label: 'Registration' }
    ],
    "WY": [
      { value: 'vehicle_registration', label: 'Registration' }
    ]
  };
  const [selectedState, setSelectedState] = useState('');
  var selectedDocument
  const [checkType, setCheckType] = useState('');

  const handleSave = () => {
    if (checkType && !selectedState) {
      onSave(checkType, "none");
    }
    else if (selectedState && checkType)  {
      selectedDocument = allowed_trans_types[selectedState][0].value

      if(selectedState == "CA") {
        selectedDocument = allowed_trans_types[selectedState][1].value
    }
      onSave(checkType, selectedState, selectedDocument);
    }
  };

  const handleChange = (event) => {
    var newValue = event.target.value
    setCheckType(newValue);

    if (newValue !== 'State_Only') {
      setSelectedState('');
    }
  };

  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
  };



  const content = (
    <div>
      <div className='text-2xl font-semibold text-gray-800 mb-2'>Choose the Check Type</div>
      <div className='text-gray-600 mb-8'>Choose the correct check type to move on to the form.</div>

      <Stack spacing={3}>
        <FormControl fullWidth>
          <InputLabel id="check-type-label">Check Type</InputLabel>
          <Select
            labelId="check-type-label"
            label="Check Type"
            value={checkType}
            onChange={handleChange}
          >
            <MenuItem value="Full_Check">Full Check</MenuItem>
            <MenuItem value="NMVTIS_Only">Title Brand Information</MenuItem>
            <MenuItem value="State_Only">Owner and Lien Holder Information</MenuItem>
          </Select>
        </FormControl>

        {checkType === 'State_Only' && (
          <FormControl fullWidth className="mt-8">
              <InputLabel id="state-selection-label">State for Check</InputLabel>
              <Select
                  labelId="state-selection-label"
                  label="State for Check"
                  value={selectedState}
                  onChange={handleStateChange}
              >
                  <MenuItem value="AL">Alabama</MenuItem>
                  <MenuItem value="AK">Alaska</MenuItem>
                  <MenuItem value="AR">Arkansas</MenuItem>
                  <MenuItem value="AZ">Arizona</MenuItem>
                  <MenuItem value="CA">California</MenuItem>
                  <MenuItem value="CO">Colorado</MenuItem>
                  <MenuItem value="DE">Delaware</MenuItem>
                  <MenuItem value="DC">District Of Columbia</MenuItem>
                  <MenuItem value="FL">Florida</MenuItem>
                  <MenuItem value="GA">Georgia</MenuItem>
                  <MenuItem value="ID">Idaho</MenuItem>
                  <MenuItem value="IA">Iowa</MenuItem>
                  <MenuItem value="KS">Kansas</MenuItem>
                  <MenuItem value="KY">Kentucky</MenuItem>
                  <MenuItem value="LA">Louisiana</MenuItem>
                  <MenuItem value="ME">Maine</MenuItem>
                  <MenuItem value="MD">Maryland</MenuItem>
                  <MenuItem value="MA">Massachusetts</MenuItem>
                  <MenuItem value="MI">Michigan</MenuItem>
                  <MenuItem value="MN">Minnesota</MenuItem>
                  <MenuItem value="MS">Mississippi</MenuItem>
                  <MenuItem value="MO">Missouri</MenuItem>
                  <MenuItem value="MT">Montana</MenuItem>
                  <MenuItem value="NE">Nebraska</MenuItem>
                  <MenuItem value="NV">Nevada</MenuItem>
                  <MenuItem value="NH">New Hampshire</MenuItem>
                  <MenuItem value="NJ">New Jersey</MenuItem>
                  <MenuItem value="NM">New Mexico</MenuItem>
                  <MenuItem value="NY">New York</MenuItem>
                  <MenuItem value="NC">North Carolina</MenuItem>
                  <MenuItem value="ND">North Dakota</MenuItem>
                  <MenuItem value="OH">Ohio</MenuItem>
                  <MenuItem value="OR">Oregon</MenuItem>
                  <MenuItem value="PA">Pennsylvania</MenuItem>
                  <MenuItem value="RI">Rhode Island</MenuItem>
                  <MenuItem value="SC">South Carolina</MenuItem>
                  <MenuItem value="TN">Tennessee</MenuItem>
                  <MenuItem value="TX">Texas</MenuItem>
                  <MenuItem value="VA">Virginia</MenuItem>
                  <MenuItem value="WV">West Virginia</MenuItem>
                  <MenuItem value="WI">Wisconsin</MenuItem>
                  <MenuItem value="WY">Wyoming</MenuItem>
              </Select>
          </FormControl>
      )}
      

      </Stack>
    </div>
  )

  const footerProps = {
    primaryButton: {
      text: "Save",
      width: '95px',
      height: '50px',
      isDisabled: !checkType
    },
    secondaryButton: {
      text: "Cancel",
      width: '95px',
      height: '50px',
    }
  }

  return (
    <DialogLayout
      title={"Check Type"}
      open={open}
      fullScreen={false}
      maxWidth="670px"
      content={content}
      onClose={onClose}
      onCloseIcon={onCloseIcon}
      onSubmit={handleSave}
      footerProps={footerProps}
    />
  );
}

export default CheckTypeDialog;
